module.exports = moment;


//////////////////
// WEBPACK FOOTER
// external "moment"
// module id = 1
// module chunks = 142